import { toFillFormat } from '@/helpers/toFillFormat';
import CountTable from './CountTable';

function IterationRisks(iterationRisksData, iterationImpediments) {
  let risksList = '';
  iterationRisksData.forEach((x) => {
    risksList += `- #${x.id}\n`;
  });
  if (!risksList) risksList = toFillFormat('None', 'grey');

  const countTable = CountTable(iterationImpediments);

  return `
## ⚠️ Risks and Impediments
${risksList}

In total, there are **${countTable.total}** impediments.

|Priority|Open Impediments (#)|Closed Impediments (#)|
${countTable.table}

### How accurate is the list of impediments?
> Are there other things that slow down development?
> Those can be internal (requirements, design, guidance, etc.) and external (client APIs, decisions, requirements, etc.).

- Comment1
- Comment2

### What are the elements that should be added to this list?
- Impediment1
- Impediment2
`;
}

export default IterationRisks;
